import React from 'react';
import { Divider, Result } from "antd";

export default function PaginaEstado(props) {
  const {status, mensaje, texto, solicitud} = props;

  const send = () => {
    if (window && window.parent) {
      window.parent.postMessage({ message: 'Event sent from method' }, '*');
    }
  }

  let div = status === "success" ? <p><span id="nroSolicitud" className="solicitud" onChange={send()}>{solicitud}</span></p> : <></>;

  return (
    <>
      <Result
        status={status}
        title={mensaje}
        extra={
          <>
          <Divider></Divider>
          <p>
            <h3>{texto}</h3>
          </p>
          {div}
          <Divider></Divider>
          </>
        }
      />
    </>
  );
}